import React from "react";
import Scroll from "../../components/shared/scroll";

//import sampleImage8 from "../../styles/images/samples/sample_8.jpg";
//import sampleImage9 from "../../styles/images/samples/sample_11.jpg";
//import sampleImage14 from "../../styles/images/samples/sample_14.mp4";

const contentSlide2: React.FC = () => {
  return (
    <group
    data-width="auto"
      data-scroll-mask="false"
      data-scroll-type="snap"
    //data-scroll-padding="20"
    >
      <Scroll>
        <group data-space="20" data-gap="10" data-wrap="no">
          <group
            data-background="main"
            data-radius="20"
            data-radius-bottom-left="0"
            data-radius-bottom-right="0"
            data-space="30"
            data-min-length="240"
            data-length="350"
            data-height="300"
            data-contain=""
            data-direction="column"
            data-align="center"
            data-justify="center"
            data-gap="20"
            data-dark=""
          >
            <group data-gap="10" data-align="center">
              <icon data-icon-size="medium">info</icon>
              <text data-weight="500" data-text-size="x-large" data-wrap="wrap">
                Information
              </text>
            </group>

            <text data-wrap="wrap" data-line="1.5">
              Nam maximus ante eu arcu mollis rhoncus. Nulla volutpat
              fringilla ante. Mauris hendrerit tristique sagittis. Cras
              egestas dapibus risus non aliquet.
            </text>
          </group>

          <group
            data-background="highlight"
            data-radius="extra-special"
            data-height="300"
            data-contain=""
            data-length="280"
            data-min-length="240"
          //data-dark=""
          >
            <group data-space="20" data-direction="column" data-align="center" data-justify="center">
              <icon data-icon-size="large" data-color="main">view_stream</icon>
              <text data-opacity="80" data-weight="700" data-text-size="x-large" data-wrap="wrap">Sample Content</text>
            </group>
          </group>

          <group
            data-background="highlight"
            data-radius="extra-special"
            data-height="300"
            data-contain=""
            data-length="280"
            data-min-length="240"
          //data-dark=""
          >
            <group data-space="20" data-direction="column" data-align="center" data-justify="center">
              <icon data-icon-size="large" data-color="main">view_stream</icon>
              <text data-opacity="80" data-weight="700" data-text-size="x-large" data-wrap="wrap">Sample Content</text>
            </group>
          </group>
        </group>
      </Scroll>
    </group>
  );
};
export default contentSlide2;
